/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_CloudInputs */



/**
* | output |
* | --- |
* | "Cloud Storage" |
*
* @param {Options_Backup_Destination_CloudInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_cloud = /** @type {((inputs?: Options_Backup_Destination_CloudInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_CloudInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloud-Speicher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archiviazione cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Облачное хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento en la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("云存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クラウドストレージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घन संग्रहण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenamento em nuvem")
	return /** @type {LocalizedString} */ ("Cloud Storage")
});